export {generated} from './lib/index.js'
